import { useEffect as e, useRef as t } from "react";
//#region src/hooks/useFocusTrap.ts
var n = (n) => {
	let r = t(null), i = (e) => {
		let t = (n ?? r.current)?.querySelectorAll([
			"a[href]",
			"button",
			"textarea",
			"input",
			"input[type=\"text\"]",
			"input[type=\"radio\"]",
			"input[type=\"checkbox\"]",
			"select"
		].join(", ")), i = t?.[0], a = t?.[t.length - 1];
		if (e.key === "Tab") {
			if (e.shiftKey) {
				document.activeElement === i && (a?.focus(), e.preventDefault());
				return;
			}
			document.activeElement === a && (i?.focus(), e.preventDefault());
		}
	};
	return e(() => {
		let e = n ?? r.current;
		return e && e.addEventListener("keydown", i), () => {
			e && e.removeEventListener("keydown", i);
		};
	}, [r.current, n]), r;
};
//#endregion
export { n as default };

//# sourceMappingURL=useFocusTrap.js.map